import { Language } from '@/interfaces/language.interface';
import { createGettext } from '@jshmrtn/vue3-gettext';
import translations from '../../../../translations/translations.json';

const flagIcon = (code: string): string => `${process.env.VUE_APP_PUBLIC_PATH}assets/flags/${code}.png`;

const languageService: {
  gettext: any;
  defaultLocale: null | string;
  availableLanguages: Record<string, { locale: string; name: string; src: string } >;
  initializeGettext: Function;
  getGettextInstance: Function;
  getAvailableGettextLocale: Function;
  setGettextLocale: Function;
  getAvailableLanguages: Function;
  getDefaultBrowserLanguage: Function;
  getDefaultLocale: Function;
  setDefaultLocale: Function;
  changeLanguage: Function;
} = {
  gettext: null,
  defaultLocale: null,
  availableLanguages: {
    cs: { locale: 'cs', name: 'Čeština', src: flagIcon('cs') },
    da: { locale: 'da', name: 'Dansk', src: flagIcon('da') },
    de: { locale: 'de', name: 'Deutsch', src: flagIcon('de') },
    en: { locale: 'en', name: 'English', src: flagIcon('en') },
    'es-419': { locale: 'es-419', name: 'Español', src: flagIcon('es-419') },
    fr: { locale: 'fr', name: 'Français', src: flagIcon('fr') },
    it: { locale: 'it', name: 'Italiano', src: flagIcon('it') },
    hu: { locale: 'hu', name: 'Magyar', src: flagIcon('hu') },
    no: { locale: 'no', name: 'Norsk', src: flagIcon('no') },
    nl: { locale: 'nl', name: 'Nederlands', src: flagIcon('nl') },
    pl: { locale: 'pl', name: 'Polski', src: flagIcon('pl') },
    'pt-br': { locale: 'pt-br', name: 'Português', src: flagIcon('pt-br') },
    fi: { locale: 'fi', name: 'Suomi', src: flagIcon('fi') },
    sv: { locale: 'sv', name: 'Svenska', src: flagIcon('sv') },
    ru: { locale: 'ru', name: 'Русский', src: flagIcon('ru') },
    ja: { locale: 'ja', name: '日本語', src: flagIcon('ja') },
    'zh-hans': { locale: 'zh-hans', name: '简体中文', src: flagIcon('zh-hans') },
    ko: { locale: 'ko', name: '한국어', src: flagIcon('ko') }
  },
  initializeGettext(): void {
    this.gettext = createGettext({
      availableLanguages: this.getAvailableGettextLocale(),
      defaultLanguage: this.getDefaultLocale(),
      translations,
      silent: true
    });
  },
  getGettextInstance(): null | any {
    return this.gettext;
  },
  getAvailableGettextLocale(): Record<string, string> {
    const availableLanguages = this.getAvailableLanguages();
    const localeKeys = Object.keys(availableLanguages);
    const gettextLocale = {};
    localeKeys.forEach((key: string) => Object.defineProperty(gettextLocale, key, { value: availableLanguages[key].name }));
    return gettextLocale;
  },
  setGettextLocale(locale: string): void {
    if (this.gettext && this.gettext.current) this.gettext.current = locale;
  },
  getAvailableLanguages(): Record<string, { locale: string; name: string; src: string }> {
    return this.availableLanguages;
  },
  getDefaultBrowserLanguage(): Language {
    const availableLanguages = this.getAvailableLanguages();
    const { language } = navigator;
    const defaultLanguage = availableLanguages[language];
    return defaultLanguage || availableLanguages.en;
  },
  getDefaultLocale(): string {
    if (!this.defaultLocale) {
      const defaultLanguage = this.getDefaultBrowserLanguage();
      return defaultLanguage.locale;
    }
    return this.defaultLocale;
  },
  setDefaultLocale(locale: string): void {
    this.defaultLocale = locale;
  },
  changeLanguage(locale: string) {
    this.setDefaultLocale(locale);
    this.setGettextLocale(locale);
    document.cookie = `${process.env.VUE_APP_COOKIE_PREFIX}django_language=${locale}`;
  }
};

export default languageService;
